/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.1.3.0 (NJsonSchema v10.0.27.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param dossier (optional) 
     * @return Success
     */
    setDossier(dossier: DossierDto | null | undefined): Observable<ResponseDto> {
        let url_ = this.baseUrl + "/api/Dossier/SetDossier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dossier);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDossier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDossier(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processSetDossier(response: HttpResponseBase): Observable<ResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    sendMail(idDossier: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Dossier/SendMail/{idDossier}";
        if (idDossier === undefined || idDossier === null)
            throw new Error("The parameter 'idDossier' must be defined.");
        url_ = url_.replace("{idDossier}", encodeURIComponent("" + idDossier)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMail(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendMail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param file (optional) 
     * @param idDossier (optional) 
     * @param typeFile (optional) 
     * @return Success
     */
    uploadFile(file: FileParameter | null | undefined, idDossier: number | null | undefined, typeFile: TypeFile | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Dossier/uploadFile?";
        if (idDossier !== undefined)
            url_ += "idDossier=" + encodeURIComponent("" + idDossier) + "&"; 
        if (typeFile !== undefined)
            url_ += "typeFile=" + encodeURIComponent("" + typeFile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getSecondAvisURL(): Observable<string> {
        let url_ = this.baseUrl + "/api/Referentiel/GetSecondAvisURL";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecondAvisURL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecondAvisURL(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetSecondAvisURL(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    getSecondAvisFrancaiseURL(): Observable<string> {
        let url_ = this.baseUrl + "/api/Referentiel/GetSecondAvisFrancaiseURL";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecondAvisURL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecondAvisURL(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    /**
     * @return Success
     */
    getSecondAvisAllowed(): Observable<string> {
        let url_ = this.baseUrl + "/api/Referentiel/GetSecondAvisAllowed";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecondAvisURL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecondAvisURL(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetSecondAvisAllowed(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getLangues(): Observable<ItemDto[]> {
        let url_ = this.baseUrl + "/api/Referentiel/GetLangues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLangues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLangues(<any>response_);
                } catch (e) {
                    return <Observable<ItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLangues(response: HttpResponseBase): Observable<ItemDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ItemDto[]>(<any[]>null);
    }

    /**
     * @return Success
     */
    getTexte(idLangue: number, code: string): Observable<RefDto> {
        let url_ = this.baseUrl + "/api/Referentiel/GetTexte/{idLangue}/{code}";
        if (idLangue === undefined || idLangue === null)
            throw new Error("The parameter 'idLangue' must be defined.");
        url_ = url_.replace("{idLangue}", encodeURIComponent("" + idLangue)); 
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTexte(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTexte(<any>response_);
                } catch (e) {
                    return <Observable<RefDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTexte(response: HttpResponseBase): Observable<RefDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTexteByLangue(idLangue: number): Observable<RefDto[]> {
        let url_ = this.baseUrl + "/api/Referentiel/GetTexte/{idLangue}";
        if (idLangue === undefined || idLangue === null)
            throw new Error("The parameter 'idLangue' must be defined.");
        url_ = url_.replace("{idLangue}", encodeURIComponent("" + idLangue)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTexteByLangue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTexteByLangue(<any>response_);
                } catch (e) {
                    return <Observable<RefDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTexteByLangue(response: HttpResponseBase): Observable<RefDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefDto[]>(<any[]>null);
    }

    /**
     * @return Success
     */
    getTypeSituations(): Observable<RefDto[]> {
        let url_ = this.baseUrl + "/api/Referentiel/GetTypeSituations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeSituations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeSituations(<any>response_);
                } catch (e) {
                    return <Observable<RefDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTypeSituations(response: HttpResponseBase): Observable<RefDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefDto[]>(<any[]>null);
    }

    /**
     * @return Success
     */
    getTypeDemandes(): Observable<RefDto[]> {
        let url_ = this.baseUrl + "/api/Referentiel/GetTypeDemandes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeDemandes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeDemandes(<any>response_);
                } catch (e) {
                    return <Observable<RefDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTypeDemandes(response: HttpResponseBase): Observable<RefDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefDto[]>(<any[]>null);
    }

    /**
     * @return Success
     */
    getTypeCouvertures(): Observable<RefDto[]> {
        let url_ = this.baseUrl + "/api/Referentiel/GetTypeCouvertures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeCouvertures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeCouvertures(<any>response_);
                } catch (e) {
                    return <Observable<RefDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTypeCouvertures(response: HttpResponseBase): Observable<RefDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefDto[]>(<any[]>null);
    }

    /**
     * @return Success
     */
    getSpecialites(): Observable<RefDto[]> {
        let url_ = this.baseUrl + "/api/Referentiel/GetSpecialites";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialites(<any>response_);
                } catch (e) {
                    return <Observable<RefDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSpecialites(response: HttpResponseBase): Observable<RefDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefDto[]>(<any[]>null);
    }

    /**
     * @return Success
     */
    getPathologies(): Observable<PathologieDto[]> {
        let url_ = this.baseUrl + "/api/Referentiel/GetPathologies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPathologies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPathologies(<any>response_);
                } catch (e) {
                    return <Observable<PathologieDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PathologieDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPathologies(response: HttpResponseBase): Observable<PathologieDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PathologieDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PathologieDto[]>(<any[]>null);
    }

    /**
     * @return Success
     */
    getConditions(): Observable<RefDto[]> {
        let url_ = this.baseUrl + "/api/Referentiel/GetConditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConditions(<any>response_);
                } catch (e) {
                    return <Observable<RefDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetConditions(response: HttpResponseBase): Observable<RefDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefDto[]>(<any[]>null);
    }

    /**
     * @return Success
     */
    getPays(): Observable<PaysDto[]> {
        let url_ = this.baseUrl + "/api/Referentiel/GetPays";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPays(<any>response_);
                } catch (e) {
                    return <Observable<PaysDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaysDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPays(response: HttpResponseBase): Observable<PaysDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaysDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaysDto[]>(<any[]>null);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    validUserTokenGoogle(token: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Security/ValidUserTokenGoogle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidUserTokenGoogle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidUserTokenGoogle(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processValidUserTokenGoogle(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

export class DossierDto implements IDossierDto {
    num?: string | undefined;
    idLangue?: number | undefined;
    typeDemande?: RefDto | undefined;
    typeSituation?: RefDto | undefined;
    typeCouverture?: RefDto | undefined;
    codeSpecialite?: RefDto | undefined;
    codePathologie?: RefDto | undefined;
    dateRendezVous?: Date | undefined;
    information?: string | undefined;
    medecin?: MedecinDto | undefined;
    patient?: PatientDto | undefined;
    demandeur?: DemandeurDto | undefined;

    constructor(data?: IDossierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.num = _data["num"];
            this.idLangue = _data["idLangue"];
            this.typeDemande = _data["typeDemande"] ? RefDto.fromJS(_data["typeDemande"]) : <any>undefined;
            this.typeSituation = _data["typeSituation"] ? RefDto.fromJS(_data["typeSituation"]) : <any>undefined;
            this.typeCouverture = _data["typeCouverture"] ? RefDto.fromJS(_data["typeCouverture"]) : <any>undefined;
            this.codeSpecialite = _data["codeSpecialite"] ? RefDto.fromJS(_data["codeSpecialite"]) : <any>undefined;
            this.codePathologie = _data["codePathologie"] ? RefDto.fromJS(_data["codePathologie"]) : <any>undefined;
            this.dateRendezVous = _data["dateRendezVous"] ? new Date(_data["dateRendezVous"].toString()) : <any>undefined;
            this.information = _data["information"];
            this.medecin = _data["medecin"] ? MedecinDto.fromJS(_data["medecin"]) : <any>undefined;
            this.patient = _data["patient"] ? PatientDto.fromJS(_data["patient"]) : <any>undefined;
            this.demandeur = _data["demandeur"] ? DemandeurDto.fromJS(_data["demandeur"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DossierDto {
        data = typeof data === 'object' ? data : {};
        let result = new DossierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["num"] = this.num;
        data["idLangue"] = this.idLangue;
        data["typeDemande"] = this.typeDemande ? this.typeDemande.toJSON() : <any>undefined;
        data["typeSituation"] = this.typeSituation ? this.typeSituation.toJSON() : <any>undefined;
        data["typeCouverture"] = this.typeCouverture ? this.typeCouverture.toJSON() : <any>undefined;
        data["codeSpecialite"] = this.codeSpecialite ? this.codeSpecialite.toJSON() : <any>undefined;
        data["codePathologie"] = this.codePathologie ? this.codePathologie.toJSON() : <any>undefined;
        data["dateRendezVous"] = this.dateRendezVous ? this.dateRendezVous.toISOString() : <any>undefined;
        data["information"] = this.information;
        data["medecin"] = this.medecin ? this.medecin.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["demandeur"] = this.demandeur ? this.demandeur.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDossierDto {
    num?: string | undefined;
    idLangue?: number | undefined;
    typeDemande?: RefDto | undefined;
    typeSituation?: RefDto | undefined;
    typeCouverture?: RefDto | undefined;
    codeSpecialite?: RefDto | undefined;
    codePathologie?: RefDto | undefined;
    dateRendezVous?: Date | undefined;
    information?: string | undefined;
    medecin?: MedecinDto | undefined;
    patient?: PatientDto | undefined;
    demandeur?: DemandeurDto | undefined;
}

export class RefDto implements IRefDto {
    code?: string | undefined;
    codeTexte?: string | undefined;
    libelle?: string | undefined;

    constructor(data?: IRefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.codeTexte = _data["codeTexte"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): RefDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeTexte"] = this.codeTexte;
        data["libelle"] = this.libelle;
        return data; 
    }
}

export interface IRefDto {
    code?: string | undefined;
    codeTexte?: string | undefined;
    libelle?: string | undefined;
}

export class MedecinDto implements IMedecinDto {
    numeroRpps?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    etablissement?: string | undefined;
    specialite?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;

    constructor(data?: IMedecinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroRpps = _data["numeroRpps"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.etablissement = _data["etablissement"];
            this.specialite = _data["specialite"];
            this.email = _data["email"];
            this.telephone = _data["telephone"];
        }
    }

    static fromJS(data: any): MedecinDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedecinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroRpps"] = this.numeroRpps;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["etablissement"] = this.etablissement;
        data["specialite"] = this.specialite;
        data["email"] = this.email;
        data["telephone"] = this.telephone;
        return data; 
    }
}

export interface IMedecinDto {
    numeroRpps?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    etablissement?: string | undefined;
    specialite?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
}

export class PatientDto implements IPatientDto {
    sexe?: string | undefined;
    nom?: string | undefined;
    nom2?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    adresse?: string | undefined;
    ville?: string | undefined;
    nationnalite?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
    telephone2?: string | undefined;
    taille?: number | undefined;
    poid?: number | undefined;
    cancer?: boolean | undefined;
    alcool?: boolean | undefined;
    fume?: boolean | undefined;
    visa?: boolean | undefined;
    allergie?: boolean | undefined;
    precision?: string | undefined;
    listeMedicament?: string | undefined;
    infection?: string | undefined;
    isContactMatin?: boolean | undefined;
    pays?: RefDto | undefined;
    conditions?: RefDto[] | undefined;

    constructor(data?: IPatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sexe = _data["sexe"];
            this.nom = _data["nom"];
            this.nom2 = _data["nom2"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
            this.adresse = _data["adresse"];
            this.ville = _data["ville"];
            this.nationnalite = _data["nationnalite"];
            this.email = _data["email"];
            this.telephone = _data["telephone"];
            this.telephone2 = _data["telephone2"];
            this.taille = _data["taille"];
            this.poid = _data["poid"];
            this.cancer = _data["cancer"];
            this.alcool = _data["alcool"];
            this.fume = _data["fume"];
            this.visa = _data["visa"];
            this.allergie = _data["allergie"];
            this.precision = _data["precision"];
            this.listeMedicament = _data["listeMedicament"];
            this.infection = _data["infection"];
            this.isContactMatin = _data["isContactMatin"];
            this.pays = _data["pays"] ? RefDto.fromJS(_data["pays"]) : <any>undefined;
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(RefDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sexe"] = this.sexe;
        data["nom"] = this.nom;
        data["nom2"] = this.nom2;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        data["adresse"] = this.adresse;
        data["ville"] = this.ville;
        data["nationnalite"] = this.nationnalite;
        data["email"] = this.email;
        data["telephone"] = this.telephone;
        data["telephone2"] = this.telephone2;
        data["taille"] = this.taille;
        data["poid"] = this.poid;
        data["cancer"] = this.cancer;
        data["alcool"] = this.alcool;
        data["fume"] = this.fume;
        data["visa"] = this.visa;
        data["allergie"] = this.allergie;
        data["precision"] = this.precision;
        data["listeMedicament"] = this.listeMedicament;
        data["infection"] = this.infection;
        data["isContactMatin"] = this.isContactMatin;
        data["pays"] = this.pays ? this.pays.toJSON() : <any>undefined;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPatientDto {
    sexe?: string | undefined;
    nom?: string | undefined;
    nom2?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    adresse?: string | undefined;
    ville?: string | undefined;
    nationnalite?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
    telephone2?: string | undefined;
    taille?: number | undefined;
    poid?: number | undefined;
    cancer?: boolean | undefined;
    alcool?: boolean | undefined;
    fume?: boolean | undefined;
    visa?: boolean | undefined;
    allergie?: boolean | undefined;
    precision?: string | undefined;
    listeMedicament?: string | undefined;
    infection?: string | undefined;
    isContactMatin?: boolean | undefined;
    pays?: RefDto | undefined;
    conditions?: RefDto[] | undefined;
}

export class DemandeurDto implements IDemandeurDto {
    nom?: string | undefined;
    prenom?: string | undefined;
    lien?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;

    constructor(data?: IDemandeurDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.lien = _data["lien"];
            this.email = _data["email"];
            this.telephone = _data["telephone"];
        }
    }

    static fromJS(data: any): DemandeurDto {
        data = typeof data === 'object' ? data : {};
        let result = new DemandeurDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["lien"] = this.lien;
        data["email"] = this.email;
        data["telephone"] = this.telephone;
        return data; 
    }
}

export interface IDemandeurDto {
    nom?: string | undefined;
    prenom?: string | undefined;
    lien?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
}

export class ResponseDto implements IResponseDto {
    value?: number | undefined;
    message?: string | undefined;

    constructor(data?: IResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["message"] = this.message;
        return data; 
    }
}

export interface IResponseDto {
    value?: number | undefined;
    message?: string | undefined;
}

export class ItemDto implements IItemDto {
    id?: number | undefined;
    code?: string | undefined;
    codeTexte?: string | undefined;
    libelle?: string | undefined;

    constructor(data?: IItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.codeTexte = _data["codeTexte"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): ItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["codeTexte"] = this.codeTexte;
        data["libelle"] = this.libelle;
        return data; 
    }
}

export interface IItemDto {
    id?: number | undefined;
    code?: string | undefined;
    codeTexte?: string | undefined;
    libelle?: string | undefined;
}

export class PathologieDto implements IPathologieDto {
    specialite?: RefDto | undefined;
    code?: string | undefined;
    codeTexte?: string | undefined;
    libelle?: string | undefined;

    constructor(data?: IPathologieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specialite = _data["specialite"] ? RefDto.fromJS(_data["specialite"]) : <any>undefined;
            this.code = _data["code"];
            this.codeTexte = _data["codeTexte"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): PathologieDto {
        data = typeof data === 'object' ? data : {};
        let result = new PathologieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialite"] = this.specialite ? this.specialite.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["codeTexte"] = this.codeTexte;
        data["libelle"] = this.libelle;
        return data; 
    }
}

export interface IPathologieDto {
    specialite?: RefDto | undefined;
    code?: string | undefined;
    codeTexte?: string | undefined;
    libelle?: string | undefined;
}

export class PaysDto implements IPaysDto {
    indicatifs?: number[] | undefined;
    code?: string | undefined;
    codeTexte?: string | undefined;
    libelle?: string | undefined;

    constructor(data?: IPaysDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["indicatifs"])) {
                this.indicatifs = [] as any;
                for (let item of _data["indicatifs"])
                    this.indicatifs!.push(item);
            }
            this.code = _data["code"];
            this.codeTexte = _data["codeTexte"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): PaysDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaysDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.indicatifs)) {
            data["indicatifs"] = [];
            for (let item of this.indicatifs)
                data["indicatifs"].push(item);
        }
        data["code"] = this.code;
        data["codeTexte"] = this.codeTexte;
        data["libelle"] = this.libelle;
        return data; 
    }
}

export interface IPaysDto {
    indicatifs?: number[] | undefined;
    code?: string | undefined;
    codeTexte?: string | undefined;
    libelle?: string | undefined;
}

export enum TypeFile {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}
